// Клиент GET /me/collection (§4/§5): коллекция + сюжет, открытые прогрессом.
// Состояние считает бэк; фронт только рендерит. Эндпоинт AllowAnonymous, поэтому
// зовём через authorizedFetch: залогиненному — Bearer из authStore (+ авто-refresh),
// гостю — обычный fetch без Authorization → бэк отдаёт каталог со всеми слотами
// заперто. Плоский fetch тут НЕ годится: токен доступа живёт только в памяти
// authStore, а не в куке, так что без Bearer сервер считает залогиненного гостем.

import { authorizedFetch } from '@/auth/authStore';
import { routes } from '@/api/routes';

export interface CollectionItem {
  id: string; kind: 'bg' | 'tool' | 'enemy'; world: string; worldIndex: number;
  title: string;          // имя самой детали («Луг», «Рампа», «Фон 1») — всегда есть
  note: string; art: string | null; glyph: string;
  unlocked: boolean; hidden: boolean; lockHint: string;
}
export interface StoryItem {
  id: string; world: string; worldIndex: number; index: number;
  title: string | null; note: string; unlocked: boolean; lockHint: string;
  videoUrl: string | null;
}
/** Заголовки секций-миров: title скрыт (null → «???») у не-достигнутого мира. */
export interface CollectionWorld { id: string; index: number; title: string | null }
export interface CollectionResponse {
  counter: { unlocked: number; total: number };
  worlds: CollectionWorld[];
  items: CollectionItem[];
  story: StoryItem[];
}

export async function loadCollection(): Promise<CollectionResponse> {
  const res = await authorizedFetch(routes.meCollection, { credentials: 'include' });
  if (!res.ok) throw new Error(`collection ${res.status}`);
  return (await res.json()) as CollectionResponse;
}
